import { useState } from "react";
import { Link } from "react-router-dom";
import { listings } from "../../../mocks/listings";

const myListings = listings.slice(0, 6).map((l, i) => ({
  ...l,
  status: (
    [
      "Yayında",
      "Onay Bekliyor",
      "Yayında",
      "Reddedildi",
      "Yayında",
      "Onay Bekliyor",
    ] as const
  )[i],
}));

const statusStyles: Record<string, string> = {
  "Yayında": "bg-emerald-50 text-emerald-600 border-emerald-200",
  "Onay Bekliyor": "bg-amber-50 text-amber-600 border-amber-200",
   Reddedildi: "bg-red-50 text-red-600 border-red-200",
};

const filters = ["Tümü", "Yayında", "Onay Bekliyor", "Reddedildi"];

function formatPrice(price: number) {
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    maximumFractionDigits: 0,
  }).format(price);
}

export default function ListingManagement() {
  const [filter, setFilter] = useState("Tümü");
  const [searchQuery, setSearchQuery] = useState("");

  const filtered = myListings.filter((l) => {
    if (filter !== "Tümü" && l.status !== filter) return false;
    if (
      searchQuery &&
      !l.title.toLowerCase().includes(searchQuery.toLowerCase())
    )
      return false;
    return true;
  });

  const stats = {
    total: myListings.length,
    yayinda: myListings.filter((l) => l.status === "Yayında").length,
    bekliyor: myListings.filter((l) => l.status === "Onay Bekliyor").length,
    reddedildi: myListings.filter((l) => l.status === "Reddedildi").length,
  };

  return (
    <div className="space-y-5 md:space-y-6">
      {/* Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        <div className="bg-white rounded-xl border border-surface-200 p-4 md:p-5">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-surface-50 text-surface-500">
              <i className="ri-file-list-line" />
            </div>
            <span className="text-xs text-surface-500">Toplam</span>
          </div>
          <p className="text-xl md:text-2xl font-bold text-surface-900">
            {stats.total}
          </p>
        </div>
        <div className="bg-white rounded-xl border border-surface-200 p-4 md:p-5">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-emerald-50 text-emerald-500">
              <i className="ri-check-line" />
            </div>
            <span className="text-xs text-surface-500">Yayında</span>
          </div>
          <p className="text-xl md:text-2xl font-bold text-emerald-600">
            {stats.yayinda}
          </p>
        </div>
        <div className="bg-white rounded-xl border border-surface-200 p-4 md:p-5">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-amber-50 text-amber-500">
              <i className="ri-time-line" />
            </div>
            <span className="text-xs text-surface-500">Onay Bekliyor</span>
          </div>
          <p className="text-xl md:text-2xl font-bold text-amber-600">
            {stats.bekliyor}
          </p>
        </div>
        <div className="bg-white rounded-xl border border-surface-200 p-4 md:p-5">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-50 text-red-500">
              <i className="ri-close-line" />
            </div>
            <span className="text-xs text-surface-500">Reddedildi</span>
          </div>
          <p className="text-xl md:text-2xl font-bold text-red-600">
            {stats.reddedildi}
          </p>
        </div>
      </div>

      {/* Filter & search bar */}
      <div className="bg-white rounded-xl border border-surface-200 p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="flex items-center gap-2 overflow-x-auto w-full sm:w-auto pb-1 sm:pb-0">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setFilter(f)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors ${
                filter === f
                  ? "bg-primary-500 text-white"
                  : "bg-surface-50 text-surface-600 hover:bg-surface-100"
              }`}
            >
              {f}
            </button>
          ))}
        </div>
        <div className="relative w-full sm:w-auto">
          <div className="w-5 h-5 flex items-center justify-center absolute left-3 top-1/2 -translate-y-1/2 text-surface-400">
            <i className="ri-search-line text-sm" />
          </div>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="İlan ara..."
            className="w-full sm:w-56 pl-9 pr-4 py-2 bg-surface-50 border border-surface-200 rounded-xl text-sm text-surface-800 placeholder:text-surface-400 focus:outline-none focus:ring-2 focus:ring-primary-200 focus:border-primary-300"
          />
        </div>
      </div>

      {/* Listings */}
      {filtered.length === 0 ? (
        <div className="bg-white rounded-xl border border-surface-200 p-12 text-center">
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-surface-50 text-surface-400 mx-auto mb-4">
            <i className="ri-file-list-3-line text-2xl" />
          </div>
          <p className="text-sm font-medium text-surface-700 mb-1">
            İlan bulunamadı
          </p>
          <p className="text-xs text-surface-500">
            Farklı bir filtre deneyin veya yeni ilan verin.
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {filtered.map((listing) => (
            <div
              key={listing.id}
              className="bg-white rounded-xl border border-surface-200 p-4 md:p-5 flex flex-col md:flex-row gap-4 md:gap-5"
            >
              <div className="shrink-0 w-full md:w-36 h-36 md:h-24 rounded-lg overflow-hidden border border-surface-100">
                <img
                  src={listing.photos[0]}
                  alt={listing.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-2">
                  <span
                    className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs font-medium ${
                      statusStyles[listing.status]
                    }`}
                  >
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i
                        className={
                          listing.status === "Yayında"
                            ? "ri-check-line"
                            : listing.status === "Onay Bekliyor"
                              ? "ri-time-line"
                              : "ri-close-line"
                        }
                      />
                    </div>
                    {listing.status}
                  </span>
                  {listing.swap && (
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-50 text-amber-600 border border-amber-200 text-xs font-medium">
                      Takas Olur
                    </span>
                  )}
                </div>
                <h3 className="text-sm font-bold text-surface-900 mb-1 truncate">
                  {listing.title}
                </h3>
                <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-surface-500 mb-3">
                  <span className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-map-pin-line" />
                    </div>
                    {listing.city}, {listing.district}
                  </span>
                  <span className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-shape-line" />
                    </div>
                    {listing.area_m2.toLocaleString("tr-TR")} m²
                  </span>
                  <span className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-money-cny-circle-line" />
                    </div>
                    {formatPrice(listing.price)}
                  </span>
                </div>
                <div className="flex items-center gap-2 flex-wrap">
                  <Link
                    to={`/ilan/${listing.id}`}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-surface-50 text-surface-600 text-xs font-medium rounded-lg hover:bg-surface-100 transition-colors"
                  >
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-eye-line" />
                    </div>
                    Görüntüle
                  </Link>
                  <button
                    type="button"
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-50 text-primary-600 text-xs font-medium rounded-lg hover:bg-primary-100 transition-colors"
                  >
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-edit-line" />
                    </div>
                    Düzenle
                  </button>
                  <button
                    type="button"
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-red-50 text-red-600 text-xs font-medium rounded-lg hover:bg-red-100 transition-colors"
                  >
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-delete-bin-line" />
                    </div>
                    Sil
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
